(function(){
    'use strict';
    angular.module('Services').factory('PackagesTableService', PackagesTableService);
    
    PackagesTableService.$inject = [
        'FleetService',
        'TableLiteFactory',
        '$timeout',
        'Units'
    ];

    function PackagesTableService(
        FleetService,
        TableLiteFactory,
        $timeout,
        Units
    ) {
        return function(data){
            const label = {
                loaded: 'Loaded',
                notloaded: 'Not loaded',
                scanned: 'Scanned',
                missing: 'Missing',
                default: 'Not scanned'
            };
            const hasConsignment = data.find(item=>item.consignmentId);
            let tableData = {
                config: {
                    noFooter: true,
                    noExtraction: true,
                    noTopOptions: false,
                    noPagination: true,
                    tableMinHeight: '15em'
                },
                headers: [{
                    label: '#',
                    viewName: 'number',
                    width: '2%',
                },{
                    label: 'Package name',
                    viewName: 'name'
                },{
                    label: 'Status',
                    viewName: 'status'
                },{
                    label: 'Quantity',
                    viewName: 'quantity'
                },{
                    label: 'Length',
                    viewName: 'lengthFormatted'
                },{
                    label: 'Width',
                    viewName: 'widthFormatted'
                },{
                    label: 'Height',
                    viewName: 'heightFormatted'
                },{
                    label: 'Cubic Weight',
                    viewName: 'cubicWeightFormatted'
                },{
                    label: 'Dead Weight',
                    viewName: 'weightFormatted'
                },{
                    label: 'Total Dead Weight',
                    viewName: 'totalDeadWeightFormatted'
                },{
                    label: 'Total Cubic Weight',
                    viewName: 'totalCubicWeightFormatted'
                }],
                data: []
            };
            if(hasConsignment){
                tableData.headers.push({
                    label: 'Consignment ID',
                    viewName: 'consignmentId'
                })
            }
            buildTableData(data);
            function buildTableData(data) {
                /*** START - Building of Data ***/
                $timeout(()=>{
                    angular.forEach(data, function (item, index) {
                        const mUnit = Units.getMeasureUnit(item.measureUnit);
                        const wUnit = Units.getWeightUnit(item.weightUnit);
                        item.number = index + 1;
                        item.name = item.name || 'Custom';
                        item.status = label[item.packageStatus || 'default'];
                        item.lengthFormatted = `${item.length} ${mUnit}`;
                        item.widthFormatted = `${item.width} ${mUnit}`;
                        item.heightFormatted = `${item.height} ${mUnit}`;
                        item.weightFormatted = `${item.weight} ${wUnit}`;
                        item.cubicWeightFormatted = `${item.cubicWeight} ${wUnit}`;
                        item.totalDeadWeightFormatted = `${item.totalDeadWeight} ${wUnit}`;
                        item.totalCubicWeightFormatted = `${item.totalCubicWeight} ${wUnit}`;
                        tableData.data.push(item);
                    });
                });
            }
            this.tableData = tableData;
        }
    }
})()


// WEBPACK FOOTER //
// ./js/services/tables/PackagesTableService.js